import { render, staticRenderFns } from "./SttDictionaryAssignToAuthUser.vue?vue&type=template&id=fae75878&scoped=true"
import script from "./SttDictionaryAssignToAuthUser.vue?vue&type=script&lang=js"
export * from "./SttDictionaryAssignToAuthUser.vue?vue&type=script&lang=js"
import style0 from "./SttDictionaryAssignToAuthUser.vue?vue&type=style&index=0&id=fae75878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae75878",
  null
  
)

export default component.exports